import { Injectable } from "@angular/core";
import { DropDownList } from "../../models/DropDownList.model";
import { ISubDivisions } from "../../models/SubDivision.model";
import { ConsultantService } from "../../services/consultant.service";


@Injectable()

export class FilterBuilder {

    allSubDivisions: Array<ISubDivisions>;
    selectedSubDivisionItems: DropDownList[] = new Array<DropDownList>();
    subDivisionByDivision = new Array();
    dropDownSubDivisions: DropDownList[] = new Array<DropDownList>();


    constructor(
        private consultantService: ConsultantService,
    ) {}

    async buildSubDivisionFilter() {
        this.subDivisionByDivision = [];
        this.dropDownSubDivisions = [];

        this.allSubDivisions = await this.consultantService.getAllSubDivisions();
        let subDivisions = this.allSubDivisions.find(({division}) => String(division) === '1')
        this.subDivisionByDivision = subDivisions.subDivision;
        this.dropDownSubDivisions = subDivisions.subDivision.map(({code, name}) => {
        return {id: code, itemName: name}
        });
        return this.dropDownSubDivisions
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/builders/filter.builder.ts